/* eslint-disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".root_300b750c{list-style:none;margin:0;padding:0}"}]);
export const root = "root_300b750c";